module.exports = __webpack_public_path__ + "static/img/9 2021.10 国家创新创业优秀.f14b9ce0.jpg";